import styled from "styled-components";
import { Typography } from "@material-ui/core";

export const Title = styled(Typography).attrs({ variant: "h5" })`
  && {
    font-weight: bold;
  }
`;
